<div
  class="client-intake-form-control"
  [ngClass]="{ 'has-error': hasError }"
  [attr.aria-invalid]="hasError ? 'true' : 'false'"
>
  @if (shouldUseLabel) {
  <label [ngClass]="{ 'label-on-top': labelOnTop }" class="label">
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </label>
  } @if (!shouldUseLabel) {
  <div [attr.aria-label]="label" role="group" [ngClass]="{ 'label-on-top': labelOnTop }" class="label">
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </div>
  }

  <ng-template #content>
    @if (!hideLabel) {
    <span class="span-label" [attr.aria-label]="label">{{ _label }}</span>
    } @if (isOptional && !hideOptionalLabel) {
    <span class="optional-label">(Optional)</span>
    } @if (infoTooltip) {
    <common-info-icon-tooltip [message]="infoTooltip"></common-info-icon-tooltip>
    } @if (helpTooltip) {
    <common-help-icon-tooltip [helpTitle]="helpTitle" [helpTooltip]="helpTooltip"></common-help-icon-tooltip>
    } @if (helperText) {
    <div class="helper-text">
      {{ helperText }}
    </div>
    }
    <!-- some content is requiring this as inline/inline-block-->
    <div class="content">
      <ng-content></ng-content>
    </div>

    @if (detailsTitle && detailsMessage){
    <d3-details [title]="detailsTitle" [marginTop]="detailsMarginTop"
      ><div [innerHTML]="detailsMessage"></div
    ></d3-details>
    } @if (helperMessage) {
    <div class="helper-message">
      {{ helperMessage }}
    </div>
    }
  </ng-template>

  @if (hasError && showErrorMessages) { @if (errors?.customMessage) {
  <div class="error-text" [innerHTML]="errors.customMessage"></div>
  } @if (errors?.required) {
  <div class="error-text">{{ requireFieldMessage ?? abbreviatedLabel + ' is required' }}.</div>
  } @if (errors?.mask || errors?.mod10Validation || errors?.invalidPostalCode || errors?.email || errors?.pattern) {
  <div class="error-text">{{ abbreviatedLabel }} is invalid.</div>
  } @if (errors?.legalName) {
  <div class="error-text">{{ abbreviatedLabel }} cannot contain numbers or symbols.</div>
  } @if (!!errors?.minlength) {
  <div class="error-text">
    {{ abbreviatedLabel }} is invalid. Minimum length required is {{ errors.minlength.requiredLength }}, current length
    is {{ errors.minlength.actualLength }}.
  </div>
  } @if (!!errors?.maxlength) {
  <div class="error-text">
    {{ abbreviatedLabel }} is invalid. Maximum length allowed is {{ errors.maxlength.requiredLength }}, current length
    is {{ errors.maxlength.actualLength }}.
  </div>
  } @if (errors?.minDate) {
  <div class="error-text">
    @if (errors.minDate.message) {
    {{ errors.minDate.message }}. } @if (!errors.minDate.message) { {{ abbreviatedLabel }} is invalid. It cannot be less
    than {{ errors.minDate.label || (errors.minDate.min | date: 'mediumDate':'UTC') }}. }
  </div>
  } @if (errors?.maxDate) {
  <div class="error-text">
    @if (errors.maxDate.message) {
    {{ errors.maxDate.message }}. } @if (!errors.maxDate.message) { {{ abbreviatedLabel }} is invalid. It cannot be
    greater than {{ errors.maxDate.label || (errors.maxDate.max | date: 'mediumDate':'UTC') }}. }
  </div>
  } @if (errors?.min) {
  <div class="error-text">
    {{ abbreviatedLabel }} is invalid. It cannot be {{ errors.min.dataType === 'date' ? 'prior to' : 'less than' }}
    {{ errors.min.label || errors.min.min }}.
  </div>
  } @if (errors?.max) {
  <div class="error-text">
    {{ abbreviatedLabel }} is invalid. It can not be {{ errors.max.dataType === 'date' ? 'after' : 'greater than' }}
    {{ errors.max.label || errors.max.max }}.
  </div>
  } @if (errors?.shouldMatch) {
  <div class="error-text">{{ abbreviatedLabel }} is invalid. It should match {{ errors.shouldMatch.label }}.</div>
  } @if (errors?.shouldNotMatch) {
  <div class="error-text">
    {{ abbreviatedLabel }} is invalid. It should not match {{ errors.shouldNotMatch.label }}.
  </div>
  } @if (errors?.invalid_email) {
  <div class="error-text">Invalid email format.</div>
  } @if (errors?.nonUniqueUserEmail) {
  <div class="error-text">User already exists.</div>
  } @if (errors?.invalidIdLength) {
  <div class="error-text">{{ errors.invalidIdLength }}.</div>
  } }
</div>
